import { useMutation } from '@tanstack/react-query';
import api from '../lib/api.js';

// Déclenche une sync Shopify côté backend.
// Pas d'invalidation de cache ici — le caller décide quoi refetch ensuite.
export function useSyncShopifyPayouts() {
  return useMutation({
    mutationFn: () => api.post('/integrations/shopify/sync'),
  });
}
